// src/match-language.ts
function matchLanguage(language, languages) {
  if (!language) {
    return void 0;
  }
  const found = languages.find((l) => l === language);
  if (found) {
    return found;
  }
  const byPrecedence = languages.filter((l) => language.slice(0, l.length) === l);
  if (byPrecedence.length) {
    return byPrecedence.reduce((a, b) => a.length > b.length ? a : b);
  }
  const shortLanguage = language.slice(0, 2);
  const foundShort = languages.find((l) => l === shortLanguage);
  if (foundShort) {
    return foundShort;
  }
  const byPrecedenceShort = languages.find((l) => l.startsWith(shortLanguage));
  if (byPrecedenceShort) {
    return byPrecedenceShort;
  }
  return void 0;
}

export {
  matchLanguage
};
//# sourceMappingURL=chunk-EBUGNBEC.mjs.map